export default {
	project_name: 'Plataforma de Capacitaciones Grupo Boticário',
}
